import React, { useEffect } from "react";
import Export from "./export";
import tefData from "../test/tef.json";
import aleData from "../test/ale.json";
import tlmData from "../test/tlm.json";
import costData from "../test/cost.json";
// import heatMapData from "../test/heatmap.json";
// import assetsData from "../test/impcatedAssets.json";
// import weaknessesData from "../test/weakness.json";
import probaData from "../test/proba2.json";
import discoveredAssestsData from "../test/discoveredAssets.json";
import references from "../test/references.json";
import orgaDescriptionData from "../test/orgaDescription.json";
import { getExportAllData } from "../../../redux/actions/dashboardActionCreators";
import { useDispatch, useSelector } from "react-redux";

export default function ExportHandler() {
  const probaSchema = {
    data: [],
    level: {
      p1: 0,
      p2: 0,
      p3: 0,
      p4: 0,
      p5: 0,
      reconnaissance: 0,
      "resource-development": 0,
      "initial-access": 0,
      execution: 0,
      persistence: 0,
      "privilege-escalation": 0,
      "defense-evasion": 0,
      "credential-access": 0,
      discovery: 0,
      "lateral-movement": 0,
      collection: 0,
      "command-and-control": 0,
      exfiltration: 0,
      impact: 0,
    },
  };

  const exportData = useSelector((state) => state.dashboard.arrayData);
  const dipatch = useDispatch();
  const orgaID =
    useSelector((state) => state.organizationProfile.id) ||
    localStorage.getItem("orgaId");
  useEffect(async () => {
    await dipatch(getExportAllData(orgaID));
  }, [dipatch]);

  console.log("data", exportData);

  // Find each data object in the array
  const tefData = exportData.find((item) => item.tef_values)?.tef_values || [];
  const aleData = exportData.find((item) => item.ale_values)?.ale_values || [];
  const tlmData = exportData.find((item) => item.tlm_values)?.tlm_values || [];
  const costData =
    exportData.find((item) => item.cost_categories)?.cost_categories || [];
  const probaData =
    exportData.find((item) => item.proba_values)?.proba_values || probaSchema;
  // console.log("probaData : ", probaData);
  console.log(
    "probaData",
    exportData.find((item) => item.proba_values)?.proba_values
  );
  const discoveredAssestsData =
    exportData.find((item) => item.discovered_assets)?.discovered_assets || [];
  const orgaDescriptionData =
    exportData.find((item) => item.orga_description) || {};
  console.log("orgadiscription", orgaDescriptionData);
  const references =
    exportData.find((item) => item.references)?.references || [];

  return (
    <Export
      tefData={tefData}
      aleData={aleData}
      tlmData={tlmData}
      costData={costData}
      probaData={probaData}
      // heatmapData={heatMapData}
      // assetsData={assetsData}
      // weaknessesData={weaknessesData}
      discoveredAssestsData={discoveredAssestsData}
      referencesData={references}
      orgaDescriptionData={orgaDescriptionData}
    />
  );
}
